/**
 * Convenience wrapper around some turf submodules.
 */

import bboxPolygon from "@turf/bbox-polygon";

export { default as area } from "@turf/area";
export { default as bbox } from "@turf/bbox";

export { default as booleanDisjoint } from "@turf/boolean-disjoint";
export { default as booleanOverlap } from "@turf/boolean-overlap";
export { default as booleanPointInPolygon } from "@turf/boolean-point-in-polygon";
export { feature, featureCollection, lineString, multiLineString, multiPolygon, point, polygon } from "@turf/helpers";
export { randomPoint } from "@turf/random";
export { randomLineString } from "@turf/random";
export { bboxPolygon };
export { default as booleanContains } from "@turf/boolean-contains";
export { default as booleanEqual } from "@turf/boolean-equal";
export { default as booleanIntersects } from "@turf/boolean-intersects";
export { default as buffer } from "@turf/buffer";
export { default as centroid } from "@turf/centroid";
export { default as circle } from "@turf/circle";
export { default as combine } from "@turf/combine";
export { default as destination } from "@turf/destination";
export { default as difference } from "@turf/difference";
export { default as distance } from "@turf/distance";
export { default as intersect } from "@turf/intersect";
export { getCoords } from "@turf/invariant";
export { default as length } from "@turf/length";
export { default as midpoint } from "@turf/midpoint";
export { default as nearestPoint } from "@turf/nearest-point";
export { default as nearestPointOnLine } from "@turf/nearest-point-on-line";
export { default as pointOnFeature } from "@turf/point-on-feature";
export { default as polygonToLine } from "@turf/polygon-to-line";
export { default as union } from "@turf/union";
export { default as extent } from "turf-extent";

export function nullPolygon() {
  return bboxPolygon([0, 0, 0, 0]);
}
